import React, {CSSProperties} from 'react';
import './AppComponent.css';
import {HashRouter, Routes} from "react-router-dom";

import {pageDefinitions} from "./Pages/PageDefinitions";
import {Store} from "@reduxjs/toolkit";
import {AppComponentState} from "./AppReducer";
import {Route} from "react-router";
import 'bootstrap/dist/css/bootstrap.min.css';


import {AppActions} from "./AppActions";
import {
    DONE,
    getRequestStatus,
    HelpDialog,
    InvalidBrowserComponent,
    isValidBrowser,
    matchResponsive,
    NotificationHolder,
    OKCancelDialog,
    OKDialog,
    URLNavigator,
    URLRedirector,
    WSErrorDialog
} from "@pledger/frontend-commons";
import {pageManager} from "../../services/ui/AppPageManager";
import {DistributorNavigationMenuComponent} from "../../services/ui/NavigationMenu/DistributorNavigationMenuComponent";


export interface AppComponentProps {
    store : Store;
    state : AppComponentState;
}

export const queryString = require('query-string');

export class AppComponent extends React.Component<AppComponentProps> {

    shouldComponentUpdate() {
        return getRequestStatus() === DONE;
    }

    handleResize() {
        this.props.store.dispatch(AppActions.MATCH_MEDIA_ACTION.build(matchResponsive()));
    };

    componentDidMount() {
        window.addEventListener('resize', this.handleResize.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize.bind(this));
    }


    render() {
        //  const store = this.props.store;
        const state = this.props.state;
        const context = {
            store: this.props.store,
            dispatch: this.props.store.dispatch,
            globalState: state,
            appContext: state.appContext,
        };
       // const isPhone = context.appContext.isPhone;
        const errorState = {
            wsError: state.appContext.wsError
        };

        const containerStyle: CSSProperties = {
            display: 'flex',
            /*flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',*/
            height: 'auto',
        };

        const contentStyle: CSSProperties = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            flexGrow: 1
            //height: '100%',
        };

        const globalStyle: CSSProperties = {
                backgroundColor: pageManager.getPageBackgroundColor(state.appContext.pageId),
                zoom: context.appContext.zoomPercent
            };

        if (!isValidBrowser()) {
            return <InvalidBrowserComponent context={context} state={{}}/>;
        }
        const userToken = sessionStorage.getItem('userToken') ?? undefined;
        const enrollmentToken = sessionStorage.getItem('enrollmentToken') ?? undefined;

        const onClick : React.MouseEventHandler = (e) => {
            // on vire sinon les clics sur les href ne fonctionnent plus dans le footer
            //    e.preventDefault();
            //    e.stopPropagation();
            context.dispatch(AppActions.CLOSE_ALL_DROPDOWN_ACTION.build());
        };

        return (
            <div style={globalStyle} onClick={onClick}>
                <NotificationHolder/>
                <WSErrorDialog context={context} state={errorState}/>
                <OKCancelDialog context={context} state={state.okCancelDialog}/>
                <OKDialog context={context} state={state.okDialog}/>
                <HelpDialog context={context} state={state.helpDialog}/>
                <div style={containerStyle}>
                    <div>
                        <DistributorNavigationMenuComponent context={context} state={state.navigationMenu}/>
                    </div>
                    <div style={contentStyle}>
                        <HashRouter>
                            <URLNavigator state={state.urlNavigator}/>
                            <Routes>
                                <Route path="/" element={<URLRedirector to="/home"/>}/>
                                {
                                    pageDefinitions.filter(pageDefinition => pageDefinition.routeDefinition !== undefined)
                                        .map((pageDefinition, index) => pageDefinition.routeDefinition.pageComponentBuilder(pageDefinition.routeDefinition, context, state, index,userToken, enrollmentToken))
                                }
                            </Routes>
                        </HashRouter>
                    </div>
                </div>
            </div>);
    }
}

